module.exports = __webpack_public_path__ + "img/dadosUnidade.3f32c658.png";